import Vue from 'vue'
import Address from '@/types/Address.interface'
import Person, { Phone } from '@/types/Person.interface'
import Broadcast from '@/types/Broadcast.interface'
import User from '@/types/User.interface'
import Campaign from '@/types/Campaign.interface'
import Channel from '@/types/Channel.interface'
import Group from '@/types/Group.interface'
import TenantMembership from '@/types/TenantMembership.interface'
import Message from '@/types/Message.interface'
import Tenant from '@/types/Tenant.interface'
import filters from '@/utility/filters'
import Media from '@/types/Media.interface'
import ShortLink from '@/types/ShortLink.interface'

Vue.filter('addressString', function (address: Address): string {
    return filters.addressString(address)
})
Vue.filter('broadcastBadge', function (broadcast: Broadcast): string {
    return filters.broadcastBadge(broadcast)
})
Vue.filter('broadcastName', function (broadcast: Broadcast) {
    return filters.broadcastName(broadcast)
})
Vue.filter('formattedDatetime', function (datetime: string): string {
    return filters.formattedDatetime(datetime)
})
Vue.filter('campaignType', function (campaign: Campaign): string {
    return filters.campaignType(campaign)
})
Vue.filter('channelAssigned', function (channel: Channel): string {
    return filters.channelAssigned(channel)
})
Vue.filter('channelColor', function (channel: Channel): string {
    return filters.channelColor(channel)
})
Vue.filter('channelLastMsgTxt', function (channel: Channel): string {
    return filters.channelLastMsgTxt(channel)
})
Vue.filter('channelName', function (channel: Channel): string {
    return filters.channelName(channel)
})
Vue.filter('channelOpen', function (channel: Channel): boolean {
    return filters.channelOpen(channel)
})
Vue.filter('channelStatus', function (channel: Channel): string {
    return filters.channelStatus(channel)
})
Vue.filter('channelWaiting', function (channel: Channel): string {
    return filters.channelWaiting(channel)
})
Vue.filter('chatDate', function (value: string): string {
    return filters.chatDate(value)
})
Vue.filter('chatScheduleDate', function (value: string): string {
    return filters.chatScheduleDate(value)
})
Vue.filter('colorToText', function (color: string): string {
    return filters.colorToText(color)
})
Vue.filter('colorToHex', function (color: string): string {
    return filters.colorToHex(color)
})
Vue.filter('colorToOverlay', function (color: string): string {
    return filters.colorToOverlay(color)
})
Vue.filter('dateReadable', function (value: string, inbox: boolean = false): string {
    return filters.dateReadable(value, inbox)
})
Vue.filter('dateTime', function (value: string, timeOnly: boolean): string {
    return filters.dateTime(value, timeOnly)
})
Vue.filter('extensionsToString', function (extensions: Object): string {
    return filters.extensionsToString(extensions)
})
Vue.filter('fileSize', function (size: number): string {
    return filters.fileSize(size)
})
Vue.filter('groupBadge', function (group: Group): string {
    return filters.groupBadge(group)
})
Vue.filter('groupFullname', function (group: Group): string {
    return filters.groupFullname(group)
})
Vue.filter('groupIcon', function (group: Group) {
    return filters.groupIcon(group)
})
Vue.filter('groupType', function (group: Group) {
    return filters.groupType(group)
})
Vue.filter('groupPersonsCount', function (group: Group) {
    return filters.groupPersonsCount(group)
})
Vue.filter('highlight', function (str: string, searchtext: string, color: string): string {
    return filters.highlight(str, searchtext, color)
});
Vue.filter('humanDate', function (value: string): string {
    return filters.humanDate(value)
})
Vue.filter('iListIcon', function (icon: string): string {
    return filters.iListIcon(icon)
})
Vue.filter('inboundOutbound', function (isOutbound: boolean): string {
    return filters.inboundOutbound(isOutbound)
})
Vue.filter('invoiceNumber', function (value: string): string {
    return filters.invoiceNumber(value)
})
Vue.filter('iso8601', function (datetime: string): string {
    return filters.iso8601(datetime)
})
Vue.filter('mediaIcon', function (media: Media): string {
    return filters.mediaIcon(media)
})
Vue.filter('mediaIconText', function (media: Media): string {
    return filters.mediaIconText(media)
})
Vue.filter('membershipTitle', function (membership: TenantMembership): string {
    return filters.membershipTitle(membership)
});
Vue.filter('messageAuthor', function (message: Message): string {
    return filters.messageAuthor(message)
})
Vue.filter('messageError', function (message: Message): string {
    return filters.messageError(message)
})
Vue.filter('messageIcon', function (message: Message): string {
    return filters.messageIcon(message)
})
Vue.filter('messageStatus', function (message: Message): string {
    return filters.messageStatus(message)
});
Vue.filter('messageTo', function (message: Message): string {
    return filters.messageTo(message)
})
Vue.filter('messageType', function (message: Message): string {
    return filters.messageType(message)
})
Vue.filter('msisdn', function (phone: string): string {
    return filters.msisdn(phone)
})
Vue.filter('parseCommentedText', function (text: string, formatted: boolean = true): string {
    return filters.parseCommentedText(text, formatted)
})
Vue.filter('parseMessageText', function (text: string, outbound: boolean = false, comment: boolean = false): string {
    return filters.parseMessageText(text, outbound, comment)
})
Vue.filter('pascalCase', function (str: string): string {
    return filters.pascalCase(str)
})
Vue.filter('personColor', function (person: Person): string {
    return filters.personColor(person)
})
Vue.filter('personDefaultPhone', function (person: Person): string {
    return filters.personDefaultPhone(person)
})
Vue.filter('personFullNameOrEmail', function (person: Person): string {
    return filters.personFullNameOrEmail(person)
})
Vue.filter('personFullNameOrPhone', function (person: Person): string {
    return filters.personFullNameOrPhone(person)
})
Vue.filter('personIcon', function (person: Person): string {
    return filters.personIcon(person)
})
Vue.filter('personInboxName', function (person: Person): string {
    return filters.personInboxName(person)
})
Vue.filter('personInitials', function (person: Person): string {
    return filters.personInitials(person)
})
Vue.filter('personPhone', function (phone: Phone): string {
    return filters.personPhone(phone)
})
Vue.filter('personType', function (person: Person): string {
    return filters.personType(person)
})
Vue.filter('phone', function (value: string): string {
    return filters.phone(value)
})
Vue.filter('phoneTrim', function (value: string): string {
    return filters.phoneTrim(value)
})
Vue.filter('punctuate', function (str: string): string {
    return filters.punctuate(str)
})
Vue.filter('routeIcon', function (route: ShortLink): string {
    return filters.routeIcon(route)
})
Vue.filter('scheduleNextSendTime', function (value: string): string {
    return filters.scheduleNextSendTime(value)
});
Vue.filter('snakeCase', function (str: string): string {
    return filters.snakeCase(str)
})
Vue.filter('stripePrice', function (price: any): string {
    return filters.stripePrice(price)
})
Vue.filter('stripeCreditPrice', function (price: string): string {
    return filters.stripeCreditPrice(price)
})
Vue.filter('tenantName', function (tenant: Tenant): string {
    return filters.tenantName(tenant)
})
Vue.filter('timestamp', function (value: number): string {
    return filters.timestamp(value)
})
Vue.filter('trim', function (str: string): string {
    return filters.trim(str)
})
Vue.filter('truncateHTML', function (value: string, length: number): string {
    return filters.truncateHTML(value, length)
})
Vue.filter('userFullNameOrEmail', function (user: User): string {
    return filters.userFullNameOrEmail(user)
})
Vue.filter('userFullNameOrPhone', function (user: User): string {
    return filters.userFullNameOrPhone(user)
})
Vue.filter('userIcon', function (user: User): string {
    return filters.userIcon(user)
})
Vue.filter('userInboxName', function (user: User): string {
    return filters.userInboxName(user)
})
Vue.filter('userInitials', function (user: User): string {
    return filters.userInitials(user)
})
Vue.filter('userPhone', function (user: User): string {
    return filters.userPhone(user)
})
Vue.filter('withCommas', function (integer: number): string {
    return filters.withCommas(integer)
})
